import React, { useEffect } from "react";
import { useContext, useState } from "react";
import {
  LoadingContext,
  QuestionsContext,
  ReviewContext,
  ShowPageContext,
} from "../../../provider/MyContexts";
import PageLayout from "../components/PageLayout";
import { Stack } from "@mui/material";
import LoadingBox from "../components/LoadingBox";
import { checkModes, checkStateValues } from "./config";

import ReviewResults from "./ReviewResults";
import ReviewSetting from "./ReviewSetting";

export default function ReviewPage() {
  const { showPage } = useContext(ShowPageContext);

  const { selectedSheet, updateEditSheet } = useContext(QuestionsContext);

  const { reviewState, resetState } = useContext(ReviewContext);

  const { loadingState } = useContext(LoadingContext);

  const [checkMode, setCheckMode] = useState<string>(checkModes[0]);

  function handleChangeMode(mode: string) {
    setCheckMode(mode);
  }

  function switchContent() {
    if (loadingState.loading) {
      return <></>;
    }

    switch (reviewState) {
      case Object.keys(checkStateValues)[0]:
        return <ReviewResults />;
      case Object.keys(checkStateValues)[1]:
        return <ReviewResults />;
      default:
        return <ReviewSetting checkMode={checkMode} handleChangeMode={handleChangeMode} />;
    }
  }

  useEffect(() => {
    if (selectedSheet && showPage == "review") {
      updateEditSheet(selectedSheet);
    }
  }, [selectedSheet, showPage]);

  useEffect(() => {
    if (showPage === "review") {
      resetState();
    }
  }, [showPage]);

  if (showPage !== "review") {
    return null;
  }

  return (
    <PageLayout>
      {loadingState.loading && (
        <Stack flex={1} alignItems={"center"} justifyContent={"center"}>
          <LoadingBox />
        </Stack>
      )}
      {switchContent()}
    </PageLayout>
  );
}
